import { render, staticRenderFns } from "./DaftarKeluhan.vue?vue&type=template&id=40dde6b6&"
import script from "./DaftarKeluhan.vue?vue&type=script&lang=js&"
export * from "./DaftarKeluhan.vue?vue&type=script&lang=js&"
import style0 from "./DaftarKeluhan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports